import RequestLegalConsent from '@/components/requestLegalConsent';

import LegalInformationPage from '../../legalInformationPage';
import { INBOX_PAGE_ROUTES } from '../../project/Inbox2/Config/inbox.routes';

export const PAGE_ROUTES = {
  ...INBOX_PAGE_ROUTES,
  legalInformation: {
    path: '/legal-information',
    exact: false,
    component: LegalInformationPage,
  },
  requestConsent: {
    path: '/request-legal-consent',
    exact: false,
    component: RequestLegalConsent,
  },
};

export const ERRORS = {
  NETWORK_ERROR: {
    title: 'Network Error',
    message: 'Please connect to the internet. Then try again.',
  },
};
